export default __webpack_public_path__ + "89b10cfe61180a267f76b4d6eff82db6.jpg";